<template>
  <div />
</template>

<script>
  export default {
    name: 'AccountCallbackPage',
    auth: false,
    layout: 'minimal'
  };
</script>
